const inputsValidations = {
  emailRequired: "Email is required",
  nameRequired: "Name is required",
  enNameRequired: "English name is required",
  arNameRequired: "Arabic name is required",
  pickOneCategoryAtLeast: "At least one category must be selected",
  specialtyRequired: "Specialty is required",
  roleRequired: "Role is required",
  languageRequired: "Language is required",
  logoRequired: "Logo is required",
  cityRequired: "Registered city is required",
  commercialRecordRequired: "Commercial record is required",
  commercialRecordTenDigitsOnly: "Commercial record must be exactly 10 digits",
  crDocumentRequired: "Commercial record document (PDF) is required",
  delegationDocumentRequired: "Delegation document (PDF) is required",
  personalIdDocumentRequired: "Personal ID document (PDF, JPG or PNG) is required",
  bannerRequired: "Banner is required",
  categoryRequired: "Category is required",
  passwordRequired: "Password is required",
  tempPasswordRequired: "Temporary password is required",
  oldPasswordRequired: "Old password is required",
  newPasswordRequired: "New password is required",
  validEmailFormat: "Please enter a valid email format",
  businessEmailPublicProvider:
    "Please use your company email (not Gmail, Yahoo, etc.)",
  uniqeEmailRequired: "This email is used before, email should be uniqe",
  confirmNewPasswordRequired: "Confirm new password is required",
  passwordIsNotMatched: "Passwords must match",
  passwordNotFollowREGEX:
    "Password should contain at least 8 characters; mix of letters (upper and lower case), numbers, and symbols",
  nameNotFollowREGEX: "Name should not contain any special characters",
  nameNotFollowAlphabeticREGEX:
    "Name should not contain any special characters or numbers",
  englishLettersOnly: "This field only accepts English input",
  arabicLettersOnly: "This field only accepts Arabic input",
  ibanMaxLength: "IBAN number shouldn't be more than 24 characters",
  ibanMustStartWithSA: "IBAN number must start with SA",
  ibanExactLength: "IBAN number must be exactly 24 characters",
  matloobNumberWrongLength: "Matloob number should be 9 characters",
  onlyPositiveNumber: "This field only accepts integer numbers",
  mustBeGreaterThanZero: "Must be greater than 0",
  onlyPositiveNumbersWithZero: "This field only accepts 0 or integer numbers",
  onlyPositiveNumberWithMaxTwoDecimalPlaces:
    "This field only accepts integer numbers",
  userTypeRequired: "User type is required",
  eventNameRequired: "Event name is required",
  eventBriefRequired: "Event brief is required",
  startBuildUpDateNotAfterEnd:
    "Start build up date cannot be after end build up date",
  endBuildUpDateNotBeforeStart:
    "End build up date cannot be before start build up date",
  eventStartDateNotAfterEnd: "Event start date cannot be after event end date",
  eventEndDateNotBeforeStart:
    "Event end date cannot be before event start date",
  dismantlingStartDateNotAfterEnd:
    "Dismantling start date cannot be after dismantling end date",
  dismantlingEndtDateNotBeforeStart:
    "Dismantling end date cannot be before dismantling start date",
  shouldNotBeBeforeToday: "Date cannot be before today",
  dateCannotBeFuture: "Date cannot be in the future",
  invalidDate: "Please enter a valid date",
  invalidTime: "Please enter a valid time",
  maxHundredChars: "Maximum 100 chars",
  maxFiveHundredChars: "Maximum 500 chars",
  maxTowHundredChars: "Maximum 200 chars",
  maxFiftyChars: "Maximum 50 chars",
  invalidPhone: "Invalid Phone Number",
  generalFieldRequired: "This field is required",
  checkoutCannotBeBeforeCheckin: "Checkout cannot be before check-in",
  checkoutDateMustBeAfterCheckinDate:
    "Check-out date must be after check-in time",
  checkoutTimeMustBeAfterCheckinTime:
    "Check-out time must be after check-in time",
  checkoutCannotBeCleared:
    "Check-out date and time cannot be cleared once set",
  slotShiftCheckInOutsideMargin:
    "Check-in time must be within the shift time and check-in margin",
  slotShiftCheckOutOutsideMargin:
    "Check-out time must be within the shift time and check-out margin",
  slotTrainingCheckInOutsideMargin:
    "Check-in time must be within the training time and check-in margin",
  slotTrainingCheckOutOutsideMargin:
    "Check-out time must be within the training time and check-out margin",
  slotDateOutsideEventPeriod: "Date must be within the event period",
  slotDateTimeCannotBeFuture: "Date and time cannot be in the future",
  checkoutFieldsRequiredTogether:
    "Provide both check-out date and time, or leave both empty",
  requiredDate: "This Date is required",
  max1000: "Maximum length 1000 Chars",
  max500: "Maximum length 500 Chars",
  max300: "Maximum length 300 Chars",
  generalFieldRequiredToPublish: "This Field is required",
  eventRoleRequired: "Add at least one role",
  eventSupervisorRoleRequired: "Add at least one Supervisor role",
  eventShiftRequired: "Add at least one shift",
  eventRoleCapacityRequired: "Male and female capacity cannot both be zero",
  eventImageRequired: "Event Image is required",
  verificationMethodRequired: "Check-In Verification Method is required",
  checkinStartMarginMax: "Check-in start margin shouldn't exceed 240 minutes",
  checkinEndMarginMax: "Check-in end margin shouldn't exceed 240 minutes",
  checkinMarginsTotalMax:
    "Check-in start and end margins total shouldn't exceed 240 minutes",
  checkinMarginsTotalMin:
    "Check-in start and end margins total should be greater than 0",
  checkoutStartMarginMax: "Check-out start margin shouldn't exceed 240 minutes",
  checkoutEndMarginMax: "Check-out end margin shouldn't exceed 240 minutes",
  checkoutMarginsTotalMax:
    "Check-out start and end margins total shouldn't exceed 240 minutes",
  checkoutMarginsTotalMin:
    "Check-out start and end margins total should be greater than 0",
  marginsOverlapWithSlot:
    "The total of check-in end margin and check-out start margin should be less than the time slot duration",
  payrollAmountMustBePositive:
    "This field only accepts positive integer numbers.",
  roleNameRequired: "Role name is required",
  termsRequired: "You must accept the Terms & Conditions.",
  trainingNameInvalid:
    "This field accepts letters, numbers and special characters.",
  trainingPaidAmountInvalid:
    "This field accepts numbers up to 2 decimal points.",
  trainingEndBeforeStart:
    "End date and time can not be before start date/time",
  trainingEndTimeBeforeStartTime:
    "End time cannot be earlier than start time.",
  trainingEndMustBeBeforeEventEnd:
    "Training end date/time must be before event end date/time",
  trainingStartMustBeBeforeEventEnd:
    "Training start date/time must be before event end date/time",
  trainingConflictWithShift:
    "Training time overlaps with the shift time. Please choose a training time that does not conflict with the shift.",
  trainingLocationInvalid:
    "Please select a valid location from the map or enter a valid address.",
  pastDateTime: "Date and time cannot be in the past.",
  endDateBeforeStartDate: "End date can't be before start date",
  registrationDocumentTypeInvalid:
    "Only PDF, JPG or PNG files are allowed.",
  registrationDocumentMaxSize: "Each file must not exceed 5MB.",
  logoDimensionsError: "Image dimensions must not exceed 800×400px",
};

export default inputsValidations;
